<template>
  <lw-common-banner functionClient="PC" functionModule="fusion" userType="teacher_student" :gardenId="gardenId">
    <template v-slot:userInfo>
      <lw-user-info></lw-user-info>
    </template>
  </lw-common-banner>
<!--  <div class="lw-y-banner-template">-->
<!--    &lt;!&ndash;    <div class="header-box" :style="{backgroundImage:backgroundImgC}">&ndash;&gt;-->
<!--    &lt;!&ndash;    <div class="header-box" :style="{backgroundImage:`url(${require('../../assets/images/'+bgpath)})`}">&ndash;&gt;-->
<!--    <div class="header-box">-->
<!--      <img-->
<!--        class="header-box-bg"-->
<!--        src="../../assets/images/background.png"-->
<!--        :style="{ left: `${posionLeft}px` }"-->
<!--      />-->

<!--      <div class="login-info" id="loginInfo">-->
<!--        <div class="logo">-->
<!--          <el-image :src="logSrc" alt :key="logSrc"></el-image>-->
<!--        </div>-->
<!--        <div class="cente">-->
<!--          <img src="../../assets/images/sologan.png" />-->
<!--        </div>-->
<!--        <div class="right">-->
<!--          <lw-user-info></lw-user-info>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
export default {
  name: "StudentBannerComponent",
  props: {},
  data() {
    return {
      gardenId: ''
    };
  },

  async created() {
    this.gardenId = this.local$.getItem('gardenId')
  },
  methods: {
  }
};
</script>
<style scoped lang="scss">

</style>
